<template>
<div>
  <div class="order-main">
    <div style="font-size: small;margin: 10px">{{ orderAppeal }}</div>
    <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>
    <div class="order-first-div" style="background-color: white; color: gray">
      <div style="margin: 10px;">
        <van-icon :name="iconUrl"/>
        <span>{{ plateformordertype }}</span>
      </div>
    </div>
    <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>
    <van-card
        :thumb="cardData.thumbUrl">
      <template #tags>
        <div class="end-box">
          <div class="leftArea" style="font-size: small">
            <div>订单编号：<span style="color: #4d84e2">{{ cardData.orderNumbers }}</span></div>
            <div style="margin-top: 2px;">任务类型：<span style="color: #4d84e2">{{ cardData.orderType }}</span></div>
            <div style="margin-top: 3px;"><span style="border: 1px solid red;background-color: red;color: white">{{cardData.plateform}}</span><span style="border: 1px solid gray;color: white; margin-left: 10px;background-color: gray">{{ cardData.refreeType }}</span></div>
          </div>
        </div>
      </template>
    </van-card>
    <van-cell is-link @click="showBeacuse = true" :title="beacuseTitle"></van-cell>
    <van-action-sheet v-model:show="showBeacuse" :actions="businessOptions" @select="onSelect"></van-action-sheet>
    <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>
    <van-field
        v-model="orderAppealData.appealBeacuse"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入你的申诉说明"
        show-word-limit
    />
    <van-button size="default" type="info" style="margin-top: 20px" @click="commitAppealMsg">申诉</van-button>
  </div>
</div>
</template>

<script>
import {MessageBox, Toast} from "mint-ui";
import {commitAppealMessageInfo} from "../../api/system/mobile_taskorder";

export default {
   name: "OrderAppeal",
  data(){
  return {
    message: "",
    orderAppeal: "订单申诉",
    iconUrl: "cart-circle-o",
    plateformordertype:'手机淘宝业务',
    beacuseTitle:'请选择申诉原因',
    showBeacuse:false,
    orderAppealData:{},
    businessOptions:[
      {
        name:"任务问题",
        value:202202110008,
      },
      {
        name:"物流问题",
        value: 202202110009,
      },
      {
        name:"礼物问题",
        value: 202202110010,
      },
      {
        name: "返款问题",
        value: 202202110011,
      },
      {
        name:"其他原因",
        value:202202110012
      }
    ],
    cardData: {
      thumbUrl: "https://img01.yzcdn.cn/vant/ipad.jpeg",
      orderNumbers: "2119273",
      orderType: "普通任务",
      plateform: "平台返款",
      refreeType: "立返",
    }
  }
  },
  mounted() {
     console.log(this.$route.query)
    this.$emit("titleChange", "订单申诉");
    this.buildCardData(this.$route.query);
  },
  methods: {
    buildCardData(data){
      this.cardData.thumbUrl = data.thumbUrl;
      this.cardData.orderNumbers = data.orderNumbers;
      this.cardData.orderType = data.tasktype;
      this.plateformordertype = data.taskName;
      this.orderAppealData.orderNumbers = data.orderNumbers;
    },
    onSelect(item) {
      this.showBeacuse = false;
      this.beacuseTitle = item.name;
      this.orderAppealData.appealType = item.value;
      console.log(item.value);
    },
    commitAppealMsg(){
      commitAppealMessageInfo(this.orderAppealData).then(res=>{
        if (res.success){
          MessageBox("申诉已提交，等待审核");
          this.$router.back();
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.order-main {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  margin-left: 1%;
  width: 98%;

  .order-first-div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    max-height: 33px;
    background-color: crimson;
    font-size: small;
    color: white;
  }

  .end-box {
    font-size: small;
  }
}
</style>
